import { Link } from 'react-router-dom';
import PageHeader from './PageHeader';
import SnailOnly from './SnailOnly';
import './CommunityPartnerships.css';

export default function CommunityPartnerships() {
  return (
    <div className="cp-page">
      <PageHeader />
      <div className="cp-hero" style={{ backgroundImage: 'linear-gradient(to bottom, rgba(42,43,34,0.45) 0%, rgba(42,43,34,0.3) 100%), url(/backgrounds/community-partnerships.jpg)' }}>
        <SnailOnly className="snail-watermark" />
        <div className="cp-hero-overlay">
          <Link to="/" className="cp-back">&larr; Back to home</Link>
        </div>
      </div>
      <div className="cp-body">
        <div className="cp-inner">
          <h1 className="cp-title">Community Partnerships</h1>

          <h2 className="cp-partner-heading">In Partnership with Randwick City Council</h2>

          <p className="cp-text">
            We're excited to be collaborating with Randwick City Council as part of <strong>The Saturday Circle</strong> – a monthly community gathering at the Randwick Sustainability Hub dedicated to hands-on skill sharing, sustainability, and building local resilience.
          </p>

          <p className="cp-text">
            Each second Saturday of the month, the Hub comes alive with workshops, swaps, and activities that support a circular economy and connect us with the natural world around us. Subtle Animal will be running a rotating series of workshops throughout the year, including foraging walks, handcrafted botanical skincare, and botanical skincare for pets, plant printing on fabric with leaves flowers and bark – each experience shifting with the seasons to reflect what's growing, what's needed, and what the land has to offer.
          </p>

          <a
            href="https://www.randwick.nsw.gov.au/environment-and-sustainability/environmental-whats-on/the-saturday-circle"
            className="btn btn-primary cp-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit The Saturday Circle &rarr;
          </a>
        </div>
      </div>
    </div>
  );
}
